import { MilestoneListItem } from '../../content.types';

export const milestones: Record<string, MilestoneListItem> = {};
